import React, { ReactNode } from "react"
import { useTranslation } from "react-i18next"

import { Readonly } from "shared/ui/readonly/Readonly"

import "./styles/_social-media.scss"

export interface SocialsViewProps {
  children?: ReactNode
  label?: string | null
}

export const SocialMedia = React.memo(
  ({ label, children }: SocialsViewProps) => {
    const { t } = useTranslation()
    return (
      <Readonly.Root className="social-media">
        <Readonly.Label>{label}</Readonly.Label>
        <Readonly.Value>
          <nav
            aria-label={label || t("Footer.SocialMedia.Title")}
            className="social-media__nav"
          >
            {children}
          </nav>
        </Readonly.Value>
      </Readonly.Root>
    )
  }
)
